const lang = {
  uk: {
    nowChoosePaymentMethod: "Тепер оберіть спосіб оплати:",
    redirectingToPaymentPartner: "Встановлюю з’єднання із «Tranzzo»...",
    waitASec: "Зачекайте хвильку...",
    paymentCard: "Банківською картою, Apple Pay, Google Pay",
    privat24: "Через «Приват24»",
    transfer: "На банківський рахунок",
    test: "Тест",
    anyPaymentCard:
      "Будь-яка банківська карта, випущена в Україні чи за її межами:",
    accountTransfer: "Переказ на банківський розрахунковий рахунок",
    ifPrivat24Client:
      "Якщо ви клієнт Приватбанку і у вас підключено «Приват24»:",
    prepareYourCellPhone: "Приготуйте мобільний для контролю свого платежу.",
    makeSureCardIsActive:
      "Переконайтеся, що для вашої картки відкрита оплата в інтернеті.",
    fillInTheForms: "Введіть дані у форми нижче та натисніть блакитну кнопку.",
    prepareYourPassword: "Приготуйте пароль входу до «Приват24».",
    prepareYourCellPhoneForSms:
      "Приготуйте мобільний, на нього прийде тимчасовий пароль.",
    fillInTheForm: "Введіть номер у форму нижче та натисніть блакитну кнопку.",
    getTheOrderNumber: "Отримайте та запишіть номер замовлення.",
    payInBankOrOnline:
      "Сплатіть у найближчому до вас відділені або через інтернет-банкінг вашого банку.",
    yourPhoneNumber: "Номер вашого телефону",
    yourPhoneNumberPlaceholder: "+380...",
    phoneIsInvalid:
      "Введіть коректний номер телефону. Наприклад, +380971234567",
    pickYourCardType:
      "Оберіть тип банківської картки: Visa чи Mastercard. Клацніть по логотипу, надрукованому у її правому нижньому кутку.",
    soWeCanContactYou:
      "Щоб з вами можна було зв’язатися, якщо щось піде не так",
    paymentCardType: "Тип платіжної карти",
    specifiedInTheLowerRightCorner: "Вказано у правому нижньому кутку карти",
    secureConnectionPayment: "Оплата через захищене інтернет-з’єднання",
    openingLessonsOnRequest:
      "За потреби, попросіть відкрити доступ до того, як кошти надійдуть",
  },
  en: {},
};

export default lang["uk"];
